import { Messages } from '~src/codegen/Localize';
import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const projectSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'projects': {
    id: 'projects',
    getMenuItemDisplayValue: Messages.column_numChildren,
    subSortOptions: {
      'desc': {
        id: 'projects.desc',
        field: OrderKeys.childProjectCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumChildrenDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.childProjectCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'projects.asc',
        field: OrderKeys.childProjectCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumChildrenAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.childProjectCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'workbooks': {
    id: 'workbooks',
    getMenuItemDisplayValue: Messages.column_numWorkbooks,
    subSortOptions: {
      'desc': {
        id: 'workbooks.desc',
        field: OrderKeys.workbookCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumWorkbooksDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.workbookCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'workbooks.asc',
        field: OrderKeys.workbookCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumWorkbooksAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.workbookCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'views': {
    id: 'views',
    getMenuItemDisplayValue: Messages.column_numViews,
    subSortOptions: {
      'desc': {
        id: 'views.desc',
        field: OrderKeys.viewCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumViewsDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.viewCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'views.asc',
        field: OrderKeys.viewCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumViewsAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.viewCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'datasources': {
    id: 'datasources',
    getMenuItemDisplayValue: Messages.sortByDataSourcesCount,
    subSortOptions: {
      'desc': {
        id: 'datasources.desc',
        field: OrderKeys.datasourceCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumDatasourcesDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.datasourceCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'datasources.asc',
        field: OrderKeys.datasourceCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumDatasourcesAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.datasourceCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'databases': {
    id: 'databases',
    getMenuItemDisplayValue: Messages.sortByDatabasesCount,
    subSortOptions: {
      'desc': {
        id: 'databases.desc',
        field: OrderKeys.databasesCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumDatabasesDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.databasesCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'databases.asc',
        field: OrderKeys.databasesCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumDatabasesAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.databasesCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'table': {
    id: 'tables',
    getMenuItemDisplayValue: Messages.sortByTablesCount,
    subSortOptions: {
      'desc': {
        id: 'tables.desc',
        field: OrderKeys.tablesCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumTablesDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.tablesCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'tables.asc',
        field: OrderKeys.tablesCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumTablesAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.tablesCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'owner': SortOptions.owner,
  'createdAt': SortOptions.createdAt
  // projects DO NOT support relevance sort order
};
